import { GenderSportEnum } from 'queries';
import GENDER_SPORTS from 'constants/GenderSports';
import BASEBALL_ICON from 'images/sports/icons/baseball.svg';
import BASKETBALL_ICON from 'images/sports/icons/basketball.svg';
import BEACH_VOLLEYBALL_ICON from 'images/sports/icons/beach-volleyball.svg';
import FIELD_HOCKEY_ICON from 'images/sports/icons/field-hockey.svg';
import FLAG_FOOTBALL_ICON from 'images/sports/icons/flag-football.svg';
import FOOTBALL_ICON from 'images/sports/icons/football.svg';
import GOLF_ICON from 'images/sports/icons/golf.svg';
import ICE_HOCKEY_ICON from 'images/sports/icons/ice-hockey.svg';
import LACROSSE_ICON from 'images/sports/icons/lacrosse.svg';
import RUNNING_ICON from 'images/sports/icons/running.svg';
import SOCCER_ICON from 'images/sports/icons/soccer.svg';
import SOFTBALL_ICON from 'images/sports/icons/softball.svg';
import TENNIS_ICON from 'images/sports/icons/tennis.svg';
import ULTIMATE_FRISBEE_ICON from 'images/sports/icons/ultimate-frisbee.svg';
import VOLLEYBALL_ICON from 'images/sports/icons/volleyball.svg';
import WATER_POLO_ICON from 'images/sports/icons/water-polo.svg';
import WRESTLING_ICON from 'images/sports/icons/wrestling.svg';
import FENCING_ICON from 'images/sports/icons/fencing.png';
import BADMINTON_ICON from 'images/sports/icons/badminton.svg';
import TRACK_AND_FIELD_ICON from 'images/sports/icons/track-and-field.svg';
import GYMNASTICS_ICON from 'images/sports/icons/gymnastics.svg';
import {
  BASEBALL,
  BASKETBALL,
  BEACH_VOLLEYBALL,
  CROSS_COUNTRY,
  FIELD_HOCKEY,
  FLAG_FOOTBALL,
  FOOTBALL,
  GOLF,
  ICE_HOCKEY,
  LACROSSE,
  SOCCER,
  SOFTBALL,
  TENNIS,
  ULTIMATE_FRISBEE,
  UNIFIED_BASKETBALL,
  VOLLEYBALL,
  WATER_POLO,
  WRESTLING,
  FENCING,
  BADMINTON,
  TRACK_AND_FIELD,
  GYMNASTICS
} from 'constants/Sports';
import Image, { ImageProps } from 'components/Image';
import cn from 'classnames';
import styles from './styles/GenderSportIcon.module.scss';

export function getGenderSportIconSrc(genderSportEnum: GenderSportEnum) {
  const genderSport = GENDER_SPORTS.find(genderSport => genderSport.key === genderSportEnum)!;

  switch (genderSport.sportId) {
    case BASKETBALL:
      return BASKETBALL_ICON;
    case FOOTBALL:
      return FOOTBALL_ICON;
    case BASEBALL:
      return BASEBALL_ICON;
    case SOFTBALL:
      return SOFTBALL_ICON;
    case LACROSSE:
      return LACROSSE_ICON;
    case SOCCER:
      return SOCCER_ICON;
    case VOLLEYBALL:
      return VOLLEYBALL_ICON;
    case FIELD_HOCKEY:
      return FIELD_HOCKEY_ICON;
    case ICE_HOCKEY:
      return ICE_HOCKEY_ICON;
    case WATER_POLO:
      return WATER_POLO_ICON;
    case CROSS_COUNTRY:
      return RUNNING_ICON;
    case GOLF:
      return GOLF_ICON;
    case TENNIS:
      return TENNIS_ICON;
    case WRESTLING:
      return WRESTLING_ICON;
    case BEACH_VOLLEYBALL:
      return BEACH_VOLLEYBALL_ICON;
    case FLAG_FOOTBALL:
      return FLAG_FOOTBALL_ICON;
    case UNIFIED_BASKETBALL:
      return BASKETBALL_ICON;
    case ULTIMATE_FRISBEE:
      return ULTIMATE_FRISBEE_ICON;
    case BADMINTON:
      return BADMINTON_ICON;
    case FENCING:
      return FENCING_ICON;
    case TRACK_AND_FIELD:
      return TRACK_AND_FIELD_ICON;
    case GYMNASTICS:
      return GYMNASTICS_ICON;
  }
}

export enum GenderSportIconSize {
  SMALL = 'Small',
  MEDIUM = 'Medium'
}

export default function GenderSportIcon({
  genderSport,
  size = GenderSportIconSize.SMALL,
  className,
  ...props
}: {
  genderSport: {
    key: GenderSportEnum;
    name: string;
  };
  size?: GenderSportIconSize;
} & ImageProps) {
  return <Image src={getGenderSportIconSrc(genderSport.key)} alt={genderSport.name} className={cn(styles[size], className)} {...props} />;
}
